export function getArray(data: any): Array<unknown> {
  if (Array.isArray(data)) {
    return data;
  }
  return [data];
}

// Exclusive at the end:
// with a step
// range(5, 6) => [5]
// range(5, 8, 2) => [5, 7]
export const range = (start: number, stop: number, step = 1) =>
  Array(Math.ceil((stop - start) / step))
    .fill(start)
    .map((x, y) => x + y * step);
